import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Icons } from '@/js/libs/ui/src/V2';
import { Preset } from './styled';
export const PresetItem = memo(function PresetItem({ title, isActive, onClick, dataTestId, isCustom, range }) {
    return (_jsxs(Preset, { onClick: onClick, "$isActive": isActive, "$isCustom": isCustom, "$range": range, "data-testid": dataTestId, children: [title, isActive && _jsx(Icons.Checkmark, { size: 20, dataTestId: dataTestId ? `${dataTestId}-checkmark` : undefined })] }));
});
